export default "console.log(this.$vuetify.application.top) // 56\n";